/* global angular */

import { emailTemplates } from '@prolaera/library';
import { keyBy } from 'lodash';
import './style.less';

export default function($log, $state, $stateParams, ProfileClass, ApiClass, Swal) {
  'ngInject';
  const vm = this;
  vm.$onChanges = activate;

  const { company_id } = ProfileClass.profileComplete.profile;

  const emailTemplateDict = keyBy(emailTemplates, 'id');

  vm.submit = template => {
    const { course_id, custom_emails, event_id } = vm.event;

    if (!custom_emails) return;

    custom_emails[template.id] = template;

    const event = {
      course_id,
      custom_emails,
      event_id
    };

    return ApiClass.eventsIdPatch({ id: event_id, manage: true }, { event })
      .then(() => {
        Swal.toast('Event email template updated!');
        $state.go('^');
      })
      .catch(error => {
        $log.error(error);
        throw error;
      });
  };

  /**
   * Sets the any undefined eventInfoOptions to true
   *
   * @param {*} param0
   * @returns
   */
  function _eventInfoOptionsDefaults({ eventInfoOptions: optionsMap = {} }) {
    const eventInfoOptions = Object.keys(optionsMap).reduce((acc, key) => {
      if (optionsMap[key]) {
        acc[key] = true;
      }

      return acc;
    }, {});

    return Object.keys(eventInfoOptions).length ? { eventInfoOptions } : {};
  }

  function expose(template) {
    if ('custom_emails' in vm.event === false) vm.event.custom_emails = {};

    const templateFields = emailTemplateDict[template.id];

    if (template.id in emailTemplateDict) {
      template = {
        ...templateFields,
        ..._eventInfoOptionsDefaults(templateFields.form),
        ...template
      };
    }

    if (template.id in vm.event.custom_emails) {
      vm.event.custom_emails[template.id] = { ...template, ...vm.event.custom_emails[template.id] };
    } else {
      template.active = false;
      vm.event.custom_emails[template.id] = template;
    }

    vm.formData = vm.event.custom_emails[template.id];

    vm.loaded = true;
  }

  function activate() {
    vm.loaded = false;
    vm.formData = {};
    vm.error = {};

    if (!vm.event) return;

    ApiClass.companiesIdTypeTypeIdGet(
      {
        manage: false,
        id: company_id,
        type: 'emailTemplates',
        type_id: $stateParams.type_id
      },
      null,
      { queryParams: { 'filter:usage': 'events' } }
    )
      .then(({ data: { item: template } }) => expose(template))
      .catch(error => {
        $log.error(error);
        vm.loaded = true;
        vm.error = {
          status: true,
          refresh: activate
        };
        throw error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/email/controller.js